import { Injectable, Injector } from '@angular/core';
import { MsalAuthenticationService } from 'wtw-ui-components/';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {
  static readonly SponsorNameQueryParamName = 'sname';
  static readonly ProductIdQueryParamName = 'pid';
  static readonly MenuTypeID = '8'; // Static menu type id will be different for each portal
  static readonly ProfileName = 'Customer';

  static readonly PageName = {
    NewClaims: 'Shared.pageNewClaims',
    AccountVerification: 'Shared.pageAccountVerification',
    ClaimDetails: 'Shared.pageClaimDetails',
    Policy: 'Shared.pagePolicy',
    UploadDocuments: 'Shared.pageUploadDocuments',
    DataConsent: 'Shared.pageDataConsent',
    ReviewConfirm: 'Shared.pageReviewAndConfirm',
    YourClaims: 'Shared.pageYourClaims',
    YourPolicies: 'Shared.pageYourPolicies',
    ClaimsNotificationDeclaration: 'Shared.pageClaimDeclaration',
    ClaimSubmitted: 'Shared.pageClaimSubmitted',
    YourProfile: 'Shared.pageYourProfile'
  };

  constructor(private msalAuthenticationService: MsalAuthenticationService,
              private injector: Injector) { }

  readonly metaDataAllowSearch: string = 'index, follow';
  readonly metaDataDenySearch: string = 'noindex, nofollow';

  async getLogOutText(logoutText: string) {

    // *** If 'VoucherBasedAcces' is enable then 'LogOut' option shouldn't be shown to users *** //
    const voucherBasedAccess = sessionStorage.getItem('enableVoucherBasedAccess');
    if (voucherBasedAccess) {
      const enableVoucherBasedAccess = JSON.parse(voucherBasedAccess)._value;
      if (enableVoucherBasedAccess === true) {
        return '';
      }
    }

    // *** Once the user is 'LoggedIn' then only 'LogOut' option should be shown to users *** //
    return await this.msalAuthenticationService.authenticated().then(result => {
      if (!result) {
        return '';
      }
      return logoutText;
    });

  }

  applyTranslations(pageName: string): string {
    let response: string;
    const translate = this.injector.get(TranslateService);
    translate.get(pageName).subscribe((res) => {
      response = res;
    });
    return response;
  }

}
